export default "__VITE_ASSET__5dd9d031__"